export default "__VITE_ASSET__B6R7OlqX__"